module.exports = __webpack_public_path__ + "img/second.fc669295.jpg";